// import React, {useState} from 'react'
import React from 'react'
import ChartPie from '../Graficos/ChartPie';
import {mesesExtenso} from '../../Helpers/date';
// import {mesesExtenso3,hoje} from '../../Helpers/date';
// import Seletor from '../../App/Seletor';
import Typography from '@material-ui/core/Typography';

export default function GrupoGraph(props) {
  const { dados={} } = props;
  const {
    metrica,
    empresasById,
    grupo,
    ano,
    fdata,
    mes:m,
    total,
    modif
  } = dados;
  if (
    !metrica ||
    !empresasById ||
    !grupo ||
    !ano ||
    !fdata
  ) return null;
  let data = Object.entries(fdata).map(([Codigo,dt]) => {
    return {
      Id: Codigo,
      ...empresasById[Codigo],
      ...dt,
    }
  })
  return (
    <div>
      <Typography variant="title" color="inherit" style={{
        textAlign:"center",
        marginTop:"10px"
      }}>
        {metrica.label} {mesesExtenso[m]} / {ano}
      </Typography>
      <Typography variant="title" color="inherit" style={{
        textAlign:"center",
        marginTop:"10px"
      }}>
        {grupo.Nome}
      </Typography>
      {/* <Seletor
        fullWidth
        label={"Mês"}
        onChange={setMes}
        value={mes}
        placeholder="Selecione o mês"
        suggestions={options}
      /> */}
        <ChartPie 
          data={data}
          total={total}
          modif={modif}
          dataKey={m}
          legendKey={"Apelido"}
        />
    </div>
  )
}

